import React, {useState, useEffect} from 'react';
import Time from '../../Time';
import '../../css/App.css';
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import Permissions from '../../Permissions';

class PermissionsSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        permissionsList:[]
    }
    this.loadPermissions = this.loadPermissions.bind(this)
    this.updatePermission = this.updatePermission.bind(this)
  }

  loadPermissions = async() =>{
    let loadedPermissions = await Permissions.getAllPermissions();
    this.setState({permissionsList:loadedPermissions});
    console.log(loadedPermissions);
  }

  updatePermission = async(e) =>{
        
    let groupId = e.target.attributes.groupid.value;
    let permissionName = e.target.id;
    let stat;

    if(e.target.checked){
      stat = 1;
    }else{
      stat = 0;
    }

    var formdata = new FormData();
    formdata.append("id", groupId);
    formdata.append("value", stat);
    formdata.append("permission", permissionName);
    
    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    
    fetch("https://dashboard.realsexdoll.info/php/users/updatepermission.php", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));
  }

  componentDidMount(){
    this.loadPermissions();
  }

  
  render() {

    let tableContent;

    if(this.state.permissionsList.length>0){
        tableContent = this.state.permissionsList.map((row,i) =>
        <tr>
            <th key={i}>{row.groupName}</th>
            <td><input class="form-check-input" type="checkbox" groupid={row.groupId} defaultChecked={parseInt(row.adminNotificationsSettings)} onChange={this.updatePermission} id="adminNotificationsSettings"></input></td>
            <td><input class="form-check-input" type="checkbox" groupid={row.groupId} defaultChecked={parseInt(row.payroll)} onChange={this.updatePermission} id="payroll"></input></td>
            <td><input class="form-check-input" type="checkbox" groupid={row.groupId} defaultChecked={parseInt(row.userSettings)} onChange={this.updatePermission} id="userSettings"></input></td>
        </tr>
        )
    }else{
        tableContent =  
        <tr>
            <th></th>
            <td>Loading Permissions...</td>
            <td></td>
        </tr>
    }
    
    return(
    <div className='row'>
      <div className="col-12 bg-white py-3 mb-3">
          <h2>Permissions Options</h2>
          <table className="table">
              <thead>
                  <tr>
                      <th scope="col">Group</th>
                      <th scope="col">Notification Settings</th>
                      <th scope="col">Payroll</th>
                      <th scope="col">User Settings</th>
                  </tr>
              </thead>
              <tbody>
                {tableContent}
              </tbody>
          </table>           
      </div>
    </div>
    )
  }
}

export default PermissionsSettings;